import axios from 'axios'
import { useMutation } from '@tanstack/react-query'
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from '../Config/Config'

const saveInitialVariablesForSuite = async ({ tsid, data }) => {
    const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  
const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=saveInitialVariablesForSuite&tsid=${tsid}`, 
    data,
  )
  
  return response.data
}

const useSaveVariables = (options = {}) => {
  return useMutation({
    mutationFn: saveInitialVariablesForSuite,
    ...options,
  })
}

export default useSaveVariables